import api from '~api'

export const url = `/article-counter`

export async function getCount () {
  const { data } = await api.get(`${url}`, {
    withCredentials: true
  })

  return data.counter
}
